import shortid from 'shortid';
import * as types from './types';

export const setElementChanged = (id, initialValue, newValue) => {
  return {
    type: types.SET_ELEMENT_CHANGED,
    payload: { id, initialValue, newValue },
  };
};

export const resetDirty = () => {
  return {
    type: types.RESET_DIRTY,
  };
};

//Used for check all scenario
export const forceDirtyState = () => {
  return {
    type: types.FORCE_DIRTY_STATE,
    payload: {
      id: shortid.generate(),
    },
  };
};



// WEBPACK FOOTER //
// ./src/state/dirtyTracking/actions.js